// Mock data for Udyaan Landscaping website

export const services = [
  {
    id: 1,
    title: "Miyawaki Forests & Afforestation",
    category: "Corporate",
    description: "Rapid-growth native forests for CSR projects and Mine Reclamation. We use the Miyawaki method to create dense, self-sustaining green covers 10x faster than traditional planting.",
    image: "https://images.unsplash.com/photo-1598902168333-3d0bf039a828?auto=format&fit=crop&w=800&q=80", // Forest image
    benefits: ["10x Faster Growth", "Dust Suppression", "High Carbon Sequestration", "Biodiversity Boost"]
  },
  {
    id: 2,
    title: "Industrial & Commercial Landscaping",
    category: "Corporate",
    description: "Comprehensive green belt development for factories, corporate campuses,Road Side Plantation and industrial zones. Focused on pollution control, aesthetics, and regulatory compliance.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80", // Corporate building garden
    benefits: ["Regulatory Compliance", "Pollution Control", "Employee Wellbeing", "Low Maintenance Design"]
  },
  {
    id: 3,
    title: "Luxury Residential Gardens",
    category: "Residential",
    description: "Bespoke landscape design for farmhouses and private villas. We combine hardscaping, water bodies, and exotic planting to create your personal sanctuary.",
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=800&q=80", // Luxury garden
    benefits: ["Custom Hardscaping", "Water Features", "Privacy Screening", "Seasonal Flower Beds"]
  },
  {
    id: 4,
    title: "Mine Reclamation & Restoration",
    category: "Corporate",
    description: "Specialized ecological restoration for mining sites. We rehabilitate degraded OB Dump land using scientific soil amendment and native species selection.",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=800&q=80", // Nature restoration
    benefits: ["Soil Stabilization", "Erosion Control", "Native Species Revival", "Ecological Balance"]
  },
  {
    id: 5,
    title: "Vertical Gardens & Green Walls",
    category: "Residential",
    description: "Space-saving vertical landscaping solutions for urban homes and offices. Perfect for balconies, boundary walls, and indoor air purification.",
    image: "https://images.unsplash.com/photo-1530968464165-7a1861cbaf9f?auto=format&fit=crop&w=800&q=80", // Green wall
    benefits: ["Air Purification", "Space Efficient", "Aesthetic Appeal", "Temperature Regulation"]
  },
  {
    id: 6,
    title: "Wholesale Plant Nursery",
    category: "Residential",
    description: "Direct-from-farm supply of timber, fruit, and ornamental plants. We supply bulk orders for large projects and retail for gardening enthusiasts.",
    image: "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=800&q=80", // Nursery
    benefits: ["Healthy Root Systems", "Bulk Pricing", "Wide Variety", "Delivery Across NCR"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Odisha Mining Afforestation",
    description: "Reclaimed 50 acres of mining land using the Miyawaki method, establishing a self-sustaining ecosystem in 2 years.",
    category: "Ecological Restoration",
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb77c35e?auto=format&fit=crop&w=800&q=80",
    beforeImage: "https://images.unsplash.com/photo-1500382017468-9049fed747ef"
  },
  {
    id: 2,
    title: "Vrindavan Farmhouse Estate",
    description: "Complete landscape design including a koi pond, gazebo, and tropical plantation for a luxury weekend home.",
    category: "Landscape Design",
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=800&q=80",
    beforeImage: "https://images.pexels.com/photos/1922978/pexels-photo-1922978.jpeg"
  },
  {
    id: 3,
    title: "Noida Tech Park Green Belt",
    description: "Developed a 2km long green belt and dust suppression barrier for a major tech campus.",
    category: "Ecological Restoration",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80",
    beforeImage: "https://images.pexels.com/photos/4750272/pexels-photo-4750272.jpeg"
  },
  {
    id: 4,
    title: "Urban Terrace Makeover",
    description: "Transformed a 1500 sqft concrete terrace into a lush rooftop garden with automated drip irrigation.",
    category: "Landscape Design",
    image: "https://images.unsplash.com/photo-1530968464165-7a1861cbaf9f?auto=format&fit=crop&w=800&q=80",
    beforeImage: "https://images.pexels.com/photos/4750272/pexels-photo-4750272.jpeg"
  },
  {
    id: 5,
    title: "Industrial Bio-Fencing",
    description: "Implementation of natural bio-fences using dense bamboo plantation for perimeter security and aesthetics.",
    category: "Ecological Restoration",
    image: "https://images.unsplash.com/photo-1598902168333-3d0bf039a828?auto=format&fit=crop&w=800&q=80",
    beforeImage: "https://images.unsplash.com/photo-1696846912973-3233cc80bf86"
  },
  {
    id: 6,
    title: "Zen Garden Installation",
    description: "Minimalist Zen garden design focusing on rock formations, gravel patterns, and bonsai placement.",
    category: "Landscape Design",
    image: "https://images.unsplash.com/photo-1592419044706-39796d40f98c?auto=format&fit=crop&w=800&q=80",
    beforeImage: "https://images.pexels.com/photos/1922978/pexels-photo-1922978.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Estate Owner, New Delhi",
    content: "Udyaan Landscaping transformed our barren backyard into a thriving tropical oasis. Their knowledge of native plants really made the difference.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "CSR Head, Mining Corp",
    content: "We partnered with Udyaan for our mine reclamation project in Odisha. Their Miyawaki implementation was scientifically sound and executed perfectly.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Facility Manager, Noida",
    content: "Professional, punctual, and knowledgeable. The vertical gardens they installed in our office lobby are the highlight of our building.",
    rating: 5
  }
];

export const companyInfo = {
  name: "Udyaan Landscaping Pvt Ltd",
  tagline: "Restoring Ecosystems. Transforming Spaces.",
  subTagline: "From high-impact Miyawaki forests in mining zones to luxury residential landscapes in NCR. We engineer green solutions that last.",
  phone: "+91-7984696638",
  email: "contact@udyaanlandscaping.com",
  address: "Gajraula, Uttar Pradesh, India",
  about: {
    mission: "To bridge the gap between industrial development and ecological balance through scientific afforestation and sustainable landscaping.",
    vision: "To be India's leading partner for ecological restoration and premium horticulture services.",
    description: "Udyaan Landscaping Pvt Ltd is a Startup India recognized company specializing in ecological restoration and landscape architecture. We operate at the intersection of science and art, serving major mining corporations for afforestation while simultaneously delivering high-end aesthetic gardens for private residences.",
    experience: "With over 5 years of experience in diverse terrains—from the coal belts of Odisha,Jharkhand and Chattisgarh to the urban sprawls of Delhi NCR—we bring a unique, adaptable expertise to every project.",
    philosophy: "Nature is not just decoration; it's a system. Whether it's a 100-acre forest or a 1000 sqft terrace, we design for sustainability, biodiversity, and beauty.",
    values: [
      "Scientific Approach",
      "Ecological Sustainability",
      "Project Transparency",
      "Quality Plant Material",
      "Timely Execution",
      "Long-term Support"
    ]
  }
};

// We match these filenames to what you uploaded in public/clients/
export const clients = [
  { id: 1, name: "Vedanta", logo: "/clients/vedanta.png" },
  { id: 2, name: "L&T", logo: "/clients/lt.png" },
  { id: 3, name: "BGR", logo: "/clients/bgr.png" },
  { id: 4, name: "LOGOS", logo: "/clients/logos.jpg" },
  { id: 5, name: "BDL", logo: "/clients/bdl.png" },
  { id: 6, name: "KCC", logo: "/clients/kcc.jpg" }
];

export const blogPosts = [
  {
    id: 1,
    title: "Miyawaki Method: A Solution for Mining Belts",
    excerpt: "How the Miyawaki technique creates self-sustaining forests in 3 years and why it's perfect for mine reclamation.",
    content: "The Miyawaki method involves planting native species close together to encourage rapid upward growth. In mining belts where soil quality is poor, this method...",
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb77c35e?auto=format&fit=crop&w=800&q=80",
    author: "Udyaan Research Team",
    date: "December 5, 2024",
    category: "Ecological Restoration",
    slug: "miyawaki-method-mining-solution"
  },
  {
    id: 2,
    title: "Top 5 Plants for Delhi NCR Pollution",
    excerpt: "A guide to selecting plants that effectively absorb particulate matter and thrive in North Indian climate.",
    content: "Combatting air pollution starts at home. Plants like Snake Plant, Areca Palm, and Neem are efficient bio-filters...",
    image: "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=800&q=80",
    author: "Udyaan Horticulture Team",
    date: "November 28, 2024",
    category: "Plant Care",
    slug: "top-plants-delhi-pollution"
  },
  {
    id: 3,
    title: "The ROI of Corporate Landscaping",
    excerpt: "How investing in green spaces improves employee productivity and property valuation.",
    content: "Green spaces are not just expenses; they are investments. Studies show that employees working in green environments have 15% higher productivity...",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80",
    author: "Udyaan Business Team",
    date: "November 20, 2024",
    category: "Property Value",
    slug: "roi-corporate-landscaping"
  },
  {
    id: 4,
    title: "Sustainable Gardening Practices",
    excerpt: "Eco-friendly gardening techniques that benefit both your garden and the environment.",
    content: "Sustainable gardening focuses on water conservation, composting, using native plants, reducing chemical use...",
    image: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?auto=format&fit=crop&w=800&q=80",
    author: "Udyaan Team",
    date: "November 15, 2024",
    category: "Sustainability",
    slug: "sustainable-gardening-practices"
  },
  {
    id: 5,
    title: "Lawn Care Tips for All Seasons",
    excerpt: "Essential lawn maintenance tips to keep your grass healthy throughout the year.",
    content: "Seasonal lawn care is essential for maintaining a lush, healthy lawn. Spring requires aeration and fertilization...",
    image: "https://images.unsplash.com/photo-1592419044706-39796d40f98c?auto=format&fit=crop&w=800&q=80",
    author: "Udyaan Team",
    date: "November 8, 2024",
    category: "Lawn Care",
    slug: "lawn-care-tips-for-all-seasons"
  },
  {
    id: 6,
    title: "Irrigation Systems: A Complete Guide",
    excerpt: "Understanding different irrigation systems and choosing the right one for your landscape.",
    content: "Modern irrigation systems include drip irrigation, sprinkler systems, and smart controllers...",
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=800&q=80",
    author: "Udyaan Team",
    date: "October 30, 2024",
    category: "Irrigation",
    slug: "irrigation-systems-complete-guide"
  }
];